import { useState } from "react";
import { Form } from "react-bootstrap";
import ProfileCard from "./ProfileCard";

const ProfileAboutSection = ({ form, setForm, updateProfileSection }) => {
  const [editing, setEditing] = useState(false);

  const saveAbout = async () => {
    await updateProfileSection({
      bio: form.bio,
      industries: form.industries,
      skills: form.skills.map((s) => ({ skill: s })),
    });

    setEditing(false);
  };

  return (
    <ProfileCard
      title="About"
      isEditing={editing}
      onEdit={() => setEditing(true)}
      onSave={saveAbout}
      onCancel={() => setEditing(false)}
    >
      {!editing ? (
        <>
          <p>
            <strong>Bio:</strong> {form.bio || "Not added"}
          </p>
          <p>
            <strong>Industries:</strong> {form.industries || "Not added"}
          </p>

          <p>
            <strong>Skills:</strong>
          </p>
          <div className="chips-row">
            {form.skills.map((s, idx) => (
              <span key={idx} className="chip">
                {s}
              </span>
            ))}
          </div>
        </>
      ) : (
        <>
          <Form.Control
            className="mb-2"
            as="textarea"
            rows={3}
            placeholder="Your bio"
            value={form.bio}
            onChange={(e) => setForm((p) => ({ ...p, bio: e.target.value }))}
          />

          <Form.Control
            className="mb-2"
            placeholder="Industries (comma separated)"
            value={form.industries}
            onChange={(e) =>
              setForm((p) => ({ ...p, industries: e.target.value }))
            }
          />

          {form.skills.map((s, idx) => (
            <Form.Control
              key={idx}
              className="mb-2"
              value={s}
              onChange={(e) => {
                const updated = [...form.skills];
                updated[idx] = e.target.value;
                setForm((p) => ({ ...p, skills: updated }));
              }}
            />
          ))}
        </>
      )}
    </ProfileCard>
  );
};

export default ProfileAboutSection;
